import { Box, Grid2 as Grid, styled } from "@mui/material";

export const CardContainer = styled(Grid)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "150px",
    flexWrap: "nowrap",
    overflow: "hidden",
    gap: theme.spacing(3),
}));

export const CarouselContainer = styled(Box)(() => ({
    marginBottom: "0",
    height: "100%",
    overflow: "hidden",
    position: "relative",
    ".swiper-wrapper": {
        height: "100%",
        display: "flex",
        width: "100%",
        position: "relative",
    },
    ".swiper-slide": {
        height: "100%",
        display: "block",
        width: "100%",
        position: "relative",
        flexShrink: "0",
    },
}));
